import { sortBy } from "lodash";
import { AssetHolding } from "../../types/wallet/wallet";

export const sortAssetHoldings = <THolding extends Pick<AssetHolding, "asset">>(
  holdings: THolding[]
): THolding[] => sortBy(holdings, (holding) => holding.asset.code);
